import { apiCall } from "../../utils/api";

import { notification } from "../home/action";

import TYPE from "../../constants/type";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getResearchRewards = (payload) => async (dispatch) => {
  const { profileId, departmentId, departmentIds, startDate, endDate, status, workType } = payload;
  const params = new URLSearchParams();
  if (profileId) params.append("profileId", profileId);
  if (Array.isArray(departmentIds) && departmentIds.length > 0) {
    params.append("departmentIds", departmentIds.join(","));
  } else if (departmentId) {
    params.append("departmentId", departmentId);
  }
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (status) params.append("status", status);
  if (workType) params.append("workType", workType);

  const api = {
    ...API_URLS.RESEARCH_REWARD.getResearchRewards(),
    endPoint: `${API_URLS.RESEARCH_REWARD.getResearchRewards().endPoint}?${params.toString()}`,
  };

  dispatch({
    type: TYPE.RESEARCH_REWARD.GET_RESEARCH_REWARDS_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_CALLING] },
  });

  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_REWARD.GET_RESEARCH_REWARDS_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_SUCCESS] },
    });
    return true;
  } else {
    dispatch({
      type: TYPE.RESEARCH_REWARD.GET_RESEARCH_REWARDS_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thưởng nghiên cứu thất bại!",
      }),
    );
    return false;
  }
};

export const recalculateResearchRewards = (body) => async (dispatch) => {
  const api = API_URLS.RESEARCH_REWARD.recalculateResearchRewards();

  const payload = {
    workType: body?.workType || "scientificResearch",
    ids: Array.isArray(body?.ids) ? body.ids : [],
  };
  // Send as YYYY-MM-DD string; BE handles GMT+7 → UTC conversion to match GetRewards.
  if (body?.startDate) payload.startDate = body.startDate;
  if (body?.endDate) payload.endDate = body.endDate;

  dispatch({
    type: TYPE.RESEARCH_REWARD.RECALCULATE_RESEARCH_REWARDS_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_CALLING] },
  });

  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_REWARD.RECALCULATE_RESEARCH_REWARDS_SUCCESS,
      meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Tính thưởng thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.RESEARCH_REWARD.RECALCULATE_RESEARCH_REWARDS_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Tính thưởng thất bại!",
      }),
    );
    return false;
  }
};

const formatVnd = (n) => (n || 0).toLocaleString("vi-VN", { style: "currency", currency: "VND" });

export const updateResearchRewardStatus = (updates) => async (dispatch) => {
  const api = API_URLS.RESEARCH_REWARD.updateResearchRewardStatus();

  dispatch({
    type: TYPE.RESEARCH_REWARD.UPDATE_RESEARCH_REWARD_STATUS_LOADING,
    meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_CALLING] },
  });

  const { response, error } = await apiCall({ ...api, payload: updates });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.RESEARCH_REWARD.UPDATE_RESEARCH_REWARD_STATUS_SUCCESS,
      meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật trạng thái thưởng thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.RESEARCH_REWARD.UPDATE_RESEARCH_REWARD_STATUS_FAILURE,
      meta: { prefix: [PREFIX.RESEARCH_REWARD, PREFIX.API_FAILURE] },
    });

    // BE returns 400 with detail data for two cases:
    //   - invalid status transition: items are { id, current, next }
    //   - yearly cap violation:      items are { id, profileId, profileName, year, projected, cap, ... }
    let message = response?.data?.message || "Cập nhật trạng thái thưởng thất bại!";
    const violations = response?.data?.data;
    if (Array.isArray(violations) && violations.length > 0 && violations[0]?.cap !== undefined) {
      const lines = violations.slice(0, 5).map((v) => {
        const who = v.profileName || `Profile #${v.profileId}`;
        return `• ${who} (năm ${v.year}): ${formatVnd(v.projected)} > ${formatVnd(v.cap)}`;
      });
      message = `Vượt hạn mức thưởng năm:\n${lines.join("\n")}${
        violations.length > 5 ? `\n(và ${violations.length - 5} trường hợp khác)` : ""
      }`;
    } else if (Array.isArray(violations) && violations.length > 0 && violations[0]?.next !== undefined) {
      const lines = violations.slice(0, 5).map((v) => `• Reward #${v.id}: ${v.current || "(không rõ)"} → ${v.next}`);
      message = `Chuyển trạng thái không hợp lệ:\n${lines.join("\n")}`;
    }

    dispatch(notification({ type: "error", message, duration: 6000 }));
    return false;
  }
};

export const getScientificResearchDetail = (id) => async (dispatch) => {
  const api = API_URLS.SCIENTIFIC_RESEARCH.getScientificResearchById(id);
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    return response.data.data;
  }
  dispatch(
    notification({
      type: "error",
      message: "Lấy chi tiết công trình thất bại!",
    }),
  );
  return null;
};

